import React from 'react';

import { notFound } from '../css/Switcher.css';

export default error =>
    <div className={notFound}>
    ERROR: {error.message}
    </div>;



// WEBPACK FOOTER //
// ./src/components/Error.js